import { Record } from 'immutable';
import create from './create';

const PaperBasedHomeworkRecord = Record({
  sessionId: undefined,
  sessionIndex: undefined,
  unitId: undefined,
  unitOrderingSequence: undefined,
  lessonNumber: undefined,
  studentPaperBasedHomeworks: undefined,
  studentTutorialHomeworks: undefined,
});

class PaperBasedHomework extends PaperBasedHomeworkRecord { }

PaperBasedHomework.create = create;

export default PaperBasedHomework;



// WEBPACK FOOTER //
// ./data/PaperBasedHomework/model.js